<template>
    <div>
        <div class="col-sm-12">
            <p class="text-center paragraph" style="padding: 0px 30px">
                Before you proceed, please enter the following Captcha text
            </p>
            <vue-recaptcha
                ref="recaptcha"
                :load-recaptcha-script="true"
                :sitekey="site_key"
                @verify="onVerify"
            >
            </vue-recaptcha>
        </div>
    </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'

export default {
    components: {
        VueRecaptcha,
    },
    data() {
        return {
            robot: false,
            site_key: process.env.VUE_APP_RECAPTCHA_TOKEN,
        }
    },
    methods: {
        submit: function () {
            if (this.robot) {
                //console.log('Robot-submit')
            }
        },
        onVerify: function (response) {
            if (response) {
                this.robot = true
                //console.log('Robot-onVerify' + JSON.stringify(response))
                this.$emit('onVerify', response)
            }
        },
    },
}
</script>
